module.exports = __webpack_public_path__ + "img/avti_2.6e37cc3b.png";